<template>
  <v-container pb-0 mb-0>
    <line-chart
      :chart-data="datacollection"
      :options="options"/>
      
    <!-- <button @click="updateChart()">update</button> -->
    <v-layout row justify-end>
      <v-flex xs12 sm12 md4 lg3 xl3>
        <v-select v-model="selected_period" @change="updateChart()" label="Periode" :items="$options.period_options"></v-select>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LineChart from './LineChart.vue'
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'ChartContainer',
  components: { LineChart },
  period_options: [
    {'value': 'last_5_min', 'text': 'Laatste 5 minuten'},
    {'value': 'last_hour', 'text': 'Laatste uur'},
    {'value': 'last_24_hours', 'text': 'Laatste 24 uur'},
    {'value': 'last_30_days', 'text': 'Laatste 30 dagen'},
    {'value': 'last_365_days', 'text': 'Laatste 365 dagen'},
    {'value': 'today', 'text': 'Vandaag'},
    {'value': 'yesterday', 'text': 'Gisteren'},
    {'value': 'this_week', 'text': 'Deze week'},
    {'value': 'this_month', 'text': 'Deze maand'},
    {'value': 'this_year', 'text': 'Dit jaar'},
  ],
  data: function () {
    return {
      selected_period: 'last_24_hours',
      datacollection: {},
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              tooltipFormat: 'DD-MM-YYYY HH:mm',
              displayFormats: {
              'millisecond': 'HH:mm:ss',
              'second': 'HH:mm:ss',
              'minute': 'HH:mm',
              'hour': 'HH:mm',
              'day': 'DD-MM-YYYY',
              'week': 'DD-MM-YYYY',
              'month': 'DD-MM-YYYY',
              'quarter': 'DD-MM-YYYY',
              'year': 'DD-MM-YYYY',
            }
          },
          }],
          yAxes: [{
              scaleLabel: {
                  display: true,
                  labelString: "Watt",
              },
          }],
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              return label + ': ' + value + ' Watt'
            }
          }
        }
      }
    }
  },
  mounted() {
    this.updateChart()
    this.timer = setInterval(this.updateChart, 5000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    updateChart() {
      this.$http.secured.post('/charts', {
          'period': this.selected_period
      })
      .then(response => {
        var labels = response.data.chart_data.map(item => moment(item.time))
        var data = response.data.chart_data.map(item => item.net_power_delivered.toFixed(2))
        
        this.datacollection = {
          labels: labels,
          datasets: [
          {
            label: 'Elektriciteit',
            borderColor: '#00aaff',
            backgroundColor: 'rgba(0, 170, 255, 0.1)',
            data: data,
            pointRadius: 1,
            pointHoverRadius: 3,
          },
          /*
          {
            label: 'Gas',
            borderColor: '#ff7a00',
            backgroundColor: 'rgba(255, 122, 0, 0.1)',
            data: [166, 180, 140, 132, 188, 10]
          }
          */
        ]
        }
      })
    }
  }
}
</script>

<style scoped>
  div.container {
    position: relative;
  }
</style>
